// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h2-newuser {
    color: #FFF;
    margin: 20px 0 0 0;
}

.register-link {
    font-size: 1rem;
    text-align: center;
    padding-bottom: 25px;
}

.register-link p {
    color: #FFF;
}

.register-link a {
    color: #FFF;
    font-weight: 600;
    text-decoration: none;
}

.register-link a:hover {
    text-decoration: underline;
    color: #8CBA0B;
}

/* -- Mensagens de Sucesso -- */

.success-message {
    font-size: 14px;
    font-weight: bold;
    color: #013220;
    text-align: center;
    background-color: #FFF;
    padding: 10px;
    border-radius: 5px;
    margin: 10px 0;
    list-style-type: none;
}

/* -- Mensagens de Erro -- */

.error-message {
    font-size: 14px;
    font-weight: bold;
    color: #8B0000;
    text-align: center;
    background-color: #FFF;
    padding: 10px;
    border-radius: 5px;
    margin: 10px 0;
    list-style-type: none;
    z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/css/sg-newuser.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,+BAA+B;;AAE/B;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA,4BAA4B;;AAE5B;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,WAAW;AACf","sourcesContent":[".h2-newuser {\n    color: #FFF;\n    margin: 20px 0 0 0;\n}\n\n.register-link {\n    font-size: 1rem;\n    text-align: center;\n    padding-bottom: 25px;\n}\n\n.register-link p {\n    color: #FFF;\n}\n\n.register-link a {\n    color: #FFF;\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.register-link a:hover {\n    text-decoration: underline;\n    color: #8CBA0B;\n}\n\n/* -- Mensagens de Sucesso -- */\n\n.success-message {\n    font-size: 14px;\n    font-weight: bold;\n    color: #013220;\n    text-align: center;\n    background-color: #FFF;\n    padding: 10px;\n    border-radius: 5px;\n    margin: 10px 0;\n    list-style-type: none;\n}\n\n/* -- Mensagens de Erro -- */\n\n.error-message {\n    font-size: 14px;\n    font-weight: bold;\n    color: #8B0000;\n    text-align: center;\n    background-color: #FFF;\n    padding: 10px;\n    border-radius: 5px;\n    margin: 10px 0;\n    list-style-type: none;\n    z-index: 10;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
